export const normalizeMediaItem = (item) => {
  if (!item) return null;
  if (typeof item === 'string') {
    return {
      url: item,
      thumbnailUrl: item,
      type: 'image',
      isMain: false,
    };
  }
  const type = item.type === 'video' ? 'video' : 'image';
  const url = item.url || '';
  const thumbnailUrl = item.thumbnailUrl || url;
  if (!url) return null;
  return {
    url,
    publicId: item.publicId,
    type,
    thumbnailUrl,
    isMain: Boolean(item.isMain),
    duration: item.duration,
  };
};

export const normalizeMediaList = (items) => {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => normalizeMediaItem(item))
    .filter(Boolean);
};

export const ensureMainMedia = (items) => {
  if (!Array.isArray(items) || items.length === 0) return [];
  const list = items.map((item, index) => ({
    ...item,
    isMain: Boolean(item?.isMain) || index === 0,
  }));
  if (!list.some((item) => item.isMain)) {
    list[0].isMain = true;
  }
  return list;
};

export const setMainMediaByUrl = (items, url) =>
  items.map((item) => ({ ...item, isMain: item.url === url }));

export const removeMediaByUrl = (items, url) =>
  ensureMainMedia(items.filter((item) => item.url !== url));

export const addMediaItem = (items, media) => {
  const normalized = normalizeMediaItem(media);
  if (!normalized) return items;
  const list = [...items, { ...normalized, isMain: items.length === 0 }];
  return ensureMainMedia(list);
};
